module.exports = __webpack_public_path__ + "static/media/logo.da0442d3.png";